import { currencyOptions } from '@/src/constants/header'
import { flagMap } from '@/src/constants/flagMap'
import { getCookie } from '@/src/utils/browser'

export const getCurrencyByCode = (code: string) => {
    const currOption = currencyOptions.find(c => c.code === code)
    return currOption || currencyOptions[0]
}

export const getInitialCurrencyFromCookie = () => {
    if (typeof window !== 'undefined') {
        const cookieCurrency = getCookie('utm_currency')
        if (cookieCurrency) {
            // Handle both formats: just the code or code|symbol
            const code = cookieCurrency.includes('|') ? cookieCurrency.split('|')[0] : cookieCurrency
            const found = currencyOptions.find(c => c.code === code)
            if (found) return found
        }
    }
    return currencyOptions[0]
}

/**
 * Maps API currency data to the expected shape for dropdown
 * Filters by allowed currency codes from currencyOptions
 */
export const mapApiCurrencyOptions = (currencyData: any) => {
    if (!currencyData?.symbols) return []

    // Get the list of allowed currency codes from currencyOptions
    const allowedCurrencyCodes = currencyOptions.map(option => option.code)

    // Filter and map the API data
    return currencyData.symbols
        .filter((s: any) => allowedCurrencyCodes.includes(s.code))
        .map((s: any) => ({
            code: s.code,
            label: s.name,
            symbol: s.symbol,
            Flag: flagMap[s.code]
        }))
}
